module.exports = __webpack_public_path__ + "static/service6-1c817ac22a1f088d5cff785f814c3a18.png";